import React from 'react';
import Spinner from 'react-bootstrap/Spinner'; // Assuming you're using the react-bootstrap Spinner component

const SideNavbarLoading = () => {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
    <p style={{ fontWeight: 'bold', textAlign: 'center' }}>Loading...</p>
    <div style={{ textAlign: 'center' }}>
      <Spinner animation="grow" size="sm" />
      <Spinner animation="grow" size="sm" />
      <Spinner animation="grow" size="sm" />
      <Spinner animation="grow" size="sm" />
    </div>
  </div>
  
  );
};

export default SideNavbarLoading;
